import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";

import {
  useGetCocCollectionDetailQuery,
  useUpdateCocCollectionMutation,
} from "store/services/cocCollectionApi";

import CocCollectionForm from "./cocCollectionComponents/CocCollectionForm";
import BreadcrumbLayout from "layouts/BreadcrumbLayout";

import { useAppMeta } from "hooks";

const CocCollectionEditScreen = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const breadcrumbs = [
    { title: "COC Collection", path: "/app/crm/coc-collection/list" },
    { title: "Edit COC Collection" },
  ];

  // RTK Query
  const {
    data: cocCollectionDetail,
    isLoading: loadingCocCollection,
    error,
  } = useGetCocCollectionDetailQuery(id);

  const [updateCocCollection, { isLoading: updatingCocCollection }] =
    useUpdateCocCollectionMutation();

  // Methods
  const handleUpdateCocCollection = async (data) => {
    const _payload = { ...data, _id: id };

    try {
      await updateCocCollection(_payload).unwrap();
      toast.success("COC Collection successfully updated!");
      navigate(`/app/crm/coc-collection/${id}/detail`);
    } catch (err) {
      toast.error(
        err?.data?.message ??
          err?.message ??
          "Couldn't update COC Collection!"
      );
    }
  };

  useAppMeta("Edit COC Collection");

  return (
    <BreadcrumbLayout
      breadcrumbs={breadcrumbs}
      isBusy={loadingCocCollection || updatingCocCollection}
    >
      <BreadcrumbLayout.Error error={error} />

      <BreadcrumbLayout.Paper>
        <CocCollectionForm
          isBusy={loadingCocCollection || updatingCocCollection}
          cocCollectionDetails={cocCollectionDetail}
          onSubmit={handleUpdateCocCollection}
        />
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  );
};

export default CocCollectionEditScreen;